import React from "react";
import { BiPhoneCall, BiMailSend, BiLocationPlus } from "react-icons/bi";
import Logo from "../Logo/Logo";
import SocialList from "../SocialList/SocialList";

const Footer = () => {
  return (
    <div className="page_footer">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-3 page_footer__left">
            <Logo versione="white" width="150px" />
            {/* <SocialList /> */}
          </div>
          <div className="col-3">
            <h5>
              Sede
              <br />
              legale
            </h5>
            <p>
              <BiLocationPlus />
              Piazza del Duomo, 16 - 20123 - Milano(MI) - Italia
            </p>
            <p>
              <BiPhoneCall /> +39 0364 591467
            </p>
            <p>
              <a href="mailto:info@italimpiantisrl.eu">
                <BiMailSend /> info@italimpiantisrl.eu
              </a>
            </p>
          </div>
          <div className="col-3">
            <h5>
              Sede operativa
              <br />e amministrativa
            </h5>
            <p>
              <BiLocationPlus />
              Via delle Sorti 1/E - 25050 - Pian Camuno (BS) - Italia
            </p>
            <p>
              <BiPhoneCall /> +39 0364 591467
            </p>
            <p>
              <a href="mailto:info@italimpiantisrl.eu">
                <BiMailSend /> info@italimpiantisrl.eu
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
